import { APP_CONSTANTS } from 'utils/constants'
import variables from 'styles/_variables.scss'

export const toBoardData = (proposals, pagination) => {
  const PER_PAGE = 10
  const getLaneProposals = id => {
    if (pagination && pagination[id]) {
      return proposals[id].slice(0, pagination[id] * PER_PAGE)
    }
    return proposals[id] ? proposals[id].slice(0, PER_PAGE) : []
  }
  return {
    lanes: [
      {
        id: 'CREATION',
        title: APP_CONSTANTS.ProposalStatus.CREATION,
        cards: getLaneProposals('CREATION'),
        unfilteredCards: proposals.CREATION || [],
        style: { borderTop: `4px solid ${variables.boardColumnRed}` }
      },
      {
        id: 'CHANGES',
        title: APP_CONSTANTS.ProposalStatus.CHANGES,
        cards: getLaneProposals('CHANGES'),
        unfilteredCards: proposals.CHANGES || [],
        style: { borderTop: `4px solid ${variables.boardColumnRed}` }
      },
      {
        id: 'INTERNALREVIEW',
        title: APP_CONSTANTS.ProposalStatus.INTERNALREVIEW,
        cards: getLaneProposals('INTERNALREVIEW'),
        unfilteredCards: proposals.INTERNALREVIEW || [],
        style: { borderTop: `4px solid ${variables.boardColumnRed}` }
      },
      {
        id: 'READYTOSEND',
        title: APP_CONSTANTS.ProposalStatus.READYTOSEND,
        cards: getLaneProposals('READYTOSEND'),
        unfilteredCards: proposals.READYTOSEND || [],
        style: { borderTop: `4px solid ${variables.boardColumnRed}` }
      },
      {
        id: 'SENT',
        title: APP_CONSTANTS.ProposalStatus.SENT,
        cards: getLaneProposals('SENT'),
        unfilteredCards: proposals.SENT || [],
        style: { borderTop: `4px solid ${variables.boardColumnYellow}` }
      },
      {
        id: 'RECEIVED',
        title: APP_CONSTANTS.ProposalStatus.RECEIVED,
        cards: getLaneProposals('RECEIVED'),
        unfilteredCards: proposals.RECEIVED || [],
        style: { borderTop: `4px solid ${variables.boardColumnYellow}` }
      },
      {
        id: 'YY',
        title: APP_CONSTANTS.ProposalStatus.YY,
        cards: getLaneProposals('YY'),
        unfilteredCards: proposals.YY || [],
        style: { borderTop: `4px solid ${variables.boardColumnGreen}` }
      },
      {
        id: 'YN',
        title: APP_CONSTANTS.ProposalStatus.YN,
        cards: getLaneProposals('YN'),
        unfilteredCards: proposals.YN || [],
        style: { borderTop: `4px solid ${variables.boardColumnGreen}` }
      },
      {
        id: 'NN',
        title: APP_CONSTANTS.ProposalStatus.NN,
        cards: getLaneProposals('NN'),
        unfilteredCards: proposals.NN || [],
        style: { borderTop: `4px solid ${variables.boardColumnGreen}` }
      },
      {
        id: 'NY',
        title: APP_CONSTANTS.ProposalStatus.NY,
        cards: getLaneProposals('NY'),
        unfilteredCards: proposals.NY || [],
        style: { borderTop: `4px solid ${variables.boardColumnGreen}` }
      }
    ]
  }
}
